import { render, staticRenderFns } from "./EditCrmLabel.vue?vue&type=template&id=dca50e6c&scoped=true&"
import script from "./EditCrmLabel.vue?vue&type=script&lang=js&"
export * from "./EditCrmLabel.vue?vue&type=script&lang=js&"
import style0 from "./EditCrmLabel.vue?vue&type=style&index=0&id=dca50e6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca50e6c",
  null
  
)

export default component.exports